import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import PartyType from '../filters/PartyType.jsx';
import PartyMaster from '../filters/PartyMaster.jsx';
import { isApiResponse, isReportAccess, date_range_config } from '../helpers/utils.js';
import sampleUTIDFile from '../assets/sampleUTIDFile.xlsx';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import $ from "jquery";
import * as moment from "moment";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
class PromotionMapping extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            mvalue: {year: new Date().getFullYear(), month: 11},
            fileType:'Base and EMI',
            _notificationSystem: null,
            loading:false,
            isSubmit:false,
            promotionLists:[],
            selected: [],
            selectedPromotion:[],
            partyType:'',
            partyMasterId:'',
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            promotion_status_lists: [{label: "Not Started", value: 'not started'},
                {label: "Started", value: 'started'},
                {label: "In Progress", value: 'in progress'},
                {label: "Running", value: 'running'},
                {label: "Completed", value: 'completed'},
                {label: "Failed", value: 'failed'}
            ],
            promotion_status_val:"",
            promotion_status:[],
            selected_tab:'promotion-mapping',
            master_promotion_name:''

        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        this._get_promotions('','');
    }
    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    onChangeHandler=event=>{
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
         if(ext=='xlsx') {
             this.setState({
                 selectedFile: file
             });
         } else{
             this.handleNotificationClick("tr", 3, "Please upload valid xlsx file");
             this.setState({
                 selectedFile: file
             });
         }

    };
    fileUploadHandler = () => {
        var selected_promotion = this.state.selected;
        if(selected_promotion.length<1){
            this.handleNotificationClick("tr", 3, "Please select promotions");
            return false;
        }
        if(this.state.selectedFile===null) {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            return false;
        }
        if(this.state.master_promotion_name==='') {
            this.handleNotificationClick("tr", 3, "Please Enter Promotion Name");
            return false;
        }
        this.setState({
            isSubmit:true,
            loading:true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const data = new FormData();
        var master_promotion_name = new Date().getTime()+'_'+decoded._id+'_'+selected_promotion[0]
        data.append('file', this.state.selectedFile);
        data.append('partyType', this.state.partyType);
        data.append('partyType', this.state.partyMasterId);
        data.append('user_email', decoded.email);
        data.append('selected_promotions', this.state.selected);
        data.append('master_promotion_name', this.state.master_promotion_name);
        data.append('user_id', decoded._id);
        var file = this.state.selectedFile; //console.log(data);
        var ext = this.getFileExtension(file.name);
        console.log(data);

        if(ext=='xlsx') {
            axios.post(config.get('API_URL')+"/brandemi/upload_utid/", data,{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log(res);
                    if(res.data.error==null||res.data.error=='null') {
                        this.handleNotificationClick("tr", 1, "Data Submitted");
                        this.setState({
                            isSubmit:false,
                            loading:false,
                            selected:[],
                            master_promotion_name:''
                        })
                    }
                     else {
                        this.handleNotificationClick("tr", 3, res.data.error.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    }
                })
                .catch(err => { // then print response status
                    console.log(err);
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                })
        }
        else{
            this.handleNotificationClick("tr", 3, "Please upload valid xlsx file");
            this.setState({
                isSubmit:false,
                loading:false
            })
        }
    };

    changeFileType(e){
        this.setState({
            fileType: e.target.value
        })
    }
    onChange = (selected) => {
        console.log(selected);
        this.setState({ selected });
    };

    handlePartyType = (optionSelected, partyType) =>
    {
        //alert(partyType);
        this.setState({
            partyType:partyType,
            isChange: true,
            partyMasterId:'',

        });
        this.refs.reloadPartyMaster.getpartyMaster(partyType);

    }
    handlePartyMaster = (optionSelected, partyMaster) =>
    {

        this.setState({
            isChange: true,
            partyMasterId:partyMaster,

        });
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });

    }
    _get_promotions(type,e){
        isApiResponse(false)
        var data = {
            party_type:this.state.partyType,
            party_id: this.state.partyMasterId,
            start_date: this.state.yestSend,
            end_date: this.state.todSend
        }
        axios.post(config.get('API_URL') + '/brandemi/get_promotions/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            isApiResponse(true);
            if(Array.isArray(response.data.data) && response.data.data.length) {
                var mList = []
                response.data.data.map((promotion, index) => {
                    mList.push({value: promotion.campaign_name, label: promotion.campaign_name})
                });
                this.setState({
                    promotionLists:mList
                })
            } else {
                this.handleNotificationClick("tr", 3, "No data found for selected date!");
                this.setState({
                    promotionLists:[]
                })
            }

        })

    }
    apply_filters(type){
        this.setState({
            selected_tab:'promotion-status'
        })
        setTimeout(function(){
            this.get_promotion_status();
    }.bind(this), 200);
    }
    apply_filters1(type){
        this.setState({
            selected_tab:'promotion-mapping'
        })

    }
    get_promotion_status(){
        isApiResponse(false)
        let that = this;
        let postdatatd2 = {
            promotion_status:this.state.promotion_status_val,
            start_date: this.state.yestSend,
            end_date: this.state.todSend
        };
        //alert(idIndex);
        if ($.fn.DataTable.isDataTable('#promotionMaster')) {
            $('#promotionMaster').DataTable().clear().destroy();
        }

        var merchantDataTable1 = $('#promotionMaster').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                //"scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/brandemi/get-promotion-status",
                    type: 'POST',
                    data: postdatatd2,
                    dataSrc:function ( json ) { console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                columns: [
                    {"data":"id"},
                    {"data":"promotion_name_mapped"},
                    {"data":"created_by"},
                    {"data":"created_at"},
                    {"data":"updated_by"},
                    {"data":"updated_at"},
                    {"data":"status"}
                ],
                "columnDefs": [
                    {
                        "width": "10px",
                        "targets": 6,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {

                            var className = 'inactive-download-button';
                            var statusColumnClass = '';
                            if (rowData.status === 'completed') {
                               className = '';
                               statusColumnClass = "doneLog";
                            } else if(rowData.status === 'in progress') {
                                statusColumnClass = 'ongoingLog';
                            }
                            else if(rowData.status === 'not started') {
                                statusColumnClass = 'notStartedLog';
                            }
                            else if(rowData.status === 'Invalidate' ||rowData.status === 'failed') {
                                statusColumnClass='failedLog'
                            }

                            $(td).addClass(statusColumnClass);
                        },
                        bSortable: false,
                    },
                    {  render: function (data) {

                        if(data===null || data==='null' || data==='') {
                            return data;
                        } else {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';

                        }
                        },
                        "targets": [3,5],
                    },
                ],

            });
    }
    changeStatus(optionSelected){
        let value='';
        let statusArray = [];
        if(optionSelected.length<1){
            value = null;
            statusArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                //mids.value.map((mids1, i) => {
                    statusArray.push(mids.value)
               // });

            });
        }

        this.setState({
            promotion_status:optionSelected,
            promotion_status_val:statusArray
        });
    }
    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    render() {
        //console.log(this.state.selected)
        const { selected } = this.state;

        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Promotion Mapping</h4>
                                    {/*<p className="category"></p>*/}

                                </div>
                                <hr className="m-0"/>
                                <div className="content">
                                <div>
                                {this.state.selected_tab=='promotion-mapping'?
                                <React.Fragment>
                                <div className="col-md-3">
                                        <label>Party Type</label>
                                        <PartyType ref="partyTypeFilter" onSelectPartyType = {this.handlePartyType} />
                                    </div>

                                    <div className="col-md-3">
                                        <label>Party Master</label>
                                        <PartyMaster ref="reloadPartyMaster" onSelectPartyMaster = {this.handlePartyMaster} partyMaster = {this.state.partyMasterId}/>
                                    </div>
                                    </React.Fragment>:null}
                                    <div className="col-md-3">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                        start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                    </div>
                                    {this.state.selected_tab=='promotion-status'?
                                    <div className="col-md-3">
                                        <label>Select Status:</label>
                                        <ReactMultiSelectCheckboxes name={"status_selector"}

                                                isClearable={false}
                                                onChange={this.changeStatus.bind(this)}
                                                styles={reactSelectStyles} className="report-listbox"
                                                options={this.state.promotion_status_lists}
                                                value={this.state.promotion_status}
                                                isMulti
                                                placeholderButtonLabel="Select [Status]"
                                        />
                                    </div>:null}
                                    <div className="col-md-3 top10">
                                    {this.state.selected_tab=='promotion-mapping'?
                                        <button type="button" className="primary apply-filter" role="button" onClick={this._get_promotions.bind(this,'apply')}>Apply</button>:null}
                                        {this.state.selected_tab=='promotion-status'?
                                        <button type="button" className="primary apply-filter" role="button" onClick={this.get_promotion_status.bind(this)}>Apply</button>:null}

                                    </div>
                                    <div className="clearfix"></div>
                                     <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                </div>
                                <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.apply_filters1()}>Promotion Mapping</Tab>
                                            <Tab onClick={()=>this.apply_filters()}>Mapped Promotion-Status</Tab>
                                        </TabList>

                                        <TabPanel>
                                    <div>

                                    <div className="col-md-12 col-xs-12">
                                        <DualListBox
                                            options={this.state.promotionLists}
                                            selected={selected}
                                            onChange={this.onChange}

                                        />
                                        <div className="col-md-5  col-xs-12 top10">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Upload UTID FIle(.xlsx)</label>&nbsp;&nbsp;
                                                <a href={sampleUTIDFile} download className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                                <input type="file" name="file" className="form-control-file" onChange={this.onChangeHandler} />
                                            </div>


                                        </div>
                                        <div className="col-md-4  col-xs-12 top10">
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Promotion Name(Slot)</label>&nbsp;&nbsp;
                                                 <input className="form-control" id="master_promotion_name" name="master_promotion_name" value={this.state.master_promotion_name}
                                                       onChange={this.onChangeInput.bind(this)} />
                                            </div>
                                        </div>
                                        <div className="col-md-3  col-xs-12 top10">
                                        <br/>
                                            <div className="form-group  pull-right">
                                                <button width="100%" type="button" className="btn btn-primary" onClick={this.fileUploadHandler} disabled={this.state.isSubmit}>Schedule Mapping</button>
                                                <div className='sweet-loading'>
                                                    <BeatLoader
                                                        css={override}
                                                        sizeUnit={"px"}
                                                        size={20}
                                                        color={'#123abc'}
                                                        loading={this.state.loading}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    </div>
                                    </TabPanel>
                                        <TabPanel>
                                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                    <table id="promotionMaster" className="table table-striped table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th>Master id</th>
                                                            <th>Promotion Mapped</th>
                                                            <th>Created by</th>
                                                            <th>Created at</th>
                                                            <th>Updated by</th>
                                                            <th>Updated at</th>
                                                            <th>Status</th>


                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        </tbody>
                                                    </table>
                                                </div>
                                        </TabPanel>
                                    </Tabs>

                                        {/*<div className="col-md-3 pull-left">*/}
                                        {/*    */}
                                        {/*</div>*/}
                                        <div className="clearfix"></div>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default PromotionMapping